import { ArrowRight } from "@phosphor-icons/react"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import { Divider } from "@tokenterminal/core/ui/layout/divider/Divider"
import NextLink from "next/link"
import { Fragment } from "react"

type GetListedItem = {
  name: string
  href: string
  subheading: string
  visual?: React.ComponentType
  navVisual?: React.ComponentType
}

export const NavGetListed = ({ items }: { items: GetListedItem[] }) => {
  return (
    <div className="flex items-center gap-2">
      {items.map((item, index) => {
        const VisualComponent = item.navVisual || item.visual

        return (
          <Fragment key={item.name}>
            <NextLink
              href={item.href}
              className="group w-[275px] h-[160px] p-3 rounded-lg relative transition-[background-color_200ms] hover:bg-neutral-400/[0.07]"
            >
              <div className="flex flex-col gap-3 h-full relative z-10">
                <div className="flex flex-col gap-0.5">
                  <div className="flex items-center justify-between">
                    <div className="font-medium text-sm">{item.name}</div>
                    <Icon
                      as={ArrowRight}
                      className="w-3.5 h-3.5 shrink-0 text-fg-secondary opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                    />
                  </div>
                  <p className="text-xs text-fg-secondary text-balance">{item.subheading}</p>
                </div>
              </div>
              {VisualComponent && (
                <div
                  className="absolute inset-0 opacity-50 group-hover:opacity-90 transition-opacity duration-200 pointer-events-none z-0"
                  style={
                    {
                      "--gradient": "linear-gradient(to bottom, black 40%, transparent 95%)",
                      maskImage: "var(--gradient)",
                    } as React.CSSProperties
                  }
                >
                  <VisualComponent />
                </div>
              )}
            </NextLink>
            {index < items.length - 1 && <Divider orientation="vertical" />}
          </Fragment>
        )
      })}
    </div>
  )
}

export default NavGetListed
